const dispatchRefreshError = (detail) => {
    if (typeof window !== 'undefined') {
        window.dispatchEvent(new CustomEvent('StoreError', { detail }));
    }
};

export default ({ tokens }) => {
    tokens.refreshToken = (key, token) => {
        let params = {
            client_id: tokens.config.client_id,
            client_secret: tokens.config.client_secret,
        };

        if (token.refresh_token) {
            params = {
                ...params,
                grant_type: 'refresh_token',
                refresh_token: token.refresh_token,
                redirect_uri: '',
            };
        } else {
            params = {
                ...params,
                grant_type: 'client_credentials',
            };
        }

        const body = Object.entries(params)
            .map(([paramKey, value]) => `${encodeURIComponent(paramKey)}=${encodeURIComponent(value)}`)
            .join('&');

        const request = new Request(`${tokens.config.url}/authorizationserver/oauth/token`, {
            method: 'POST',
            headers: new Headers({
                'Accept': 'application/json',
                'Content-Type': 'application/x-www-form-urlencoded',
            }),
            body,
        });

        fetch(request).then(async (response) => {
            const data = await response.json();
            let newToken = {};

            if (response.ok) {
                newToken = {
                    token: data.access_token,
                    expires_in: data?.expires_in,
                    expires_at: Date.now() + (data?.expires_in * 1000),
                    refresh_token: data?.refresh_token,
                };

                tokens.set(key, newToken);
            } else if (
                params.grant_type === 'refresh_token' &&
                response.status === 400 &&
                data?.error === 'invalid_grant'
            ) {
                tokens.remove(key);
                dispatchRefreshError({
                    status: response.status,
                    data,
                    request: {
                        grant_type: params.grant_type,
                    },
                });
            }

            tokens.refreshQueue = tokens.refreshQueue.filter(({ id, resolver }) => {
                if (id === token.token) {
                    resolver(newToken);
                }

                return id !== token.token;
            });
        }).catch((error) => {
            console.error(error);
        });
    };

    return {};
};
